import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { API } from "../App";
import { renderMarkdownSafe } from "../lib/safeMarkdown";

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/privacy`)
      .then(res => {
        setContent(res.data.content_md);
        setUpdatedAt(res.data.updated_at);
      })
      .catch((err) => {
        console.error("Failed to load privacy policy", err);
        setContent("# Privacy Policy\n\nUnable to load privacy policy.");
      })
      .finally(() => setLoading(false));
  }, []);

  const safeHtml = useMemo(() => ({ __html: renderMarkdownSafe(content) }), [content]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-white/5 p-6">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold logo-text">TAXINEARME</Link>
          <Link to="/" className="text-white/60 hover:text-[#C5A059] flex items-center gap-2 text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto p-6 lg:p-12" data-testid="privacy-policy-content">
        {loading ? (
          <div className="flex justify-center py-20"><div className="spinner" /></div>
        ) : (
          <>
            <article className="prose-custom" dangerouslySetInnerHTML={safeHtml} />
            {updatedAt && (
              <p className="mt-12 text-white/30 text-xs italic">
                Last updated: {updatedAt.slice(0, 10)}
              </p>
            )}
          </>
        )}
      </main>
    </div>
  );
}
